import { createSlice } from "@reduxjs/toolkit";
import { getUid } from "../..//utils/utils";

const initialState = {
  data: [
    {
      id: getUid(),
      name: "",
      fatherLastName: "",
      motherLastName: "",
      relationship: "",
      date: {
        day: "",
        month: "",
        year: "",
      },
      dateBirth: "",
      profitPercentage: "",
      sameAddress: "",
      confirmAddress: {
        postalCode: "",
        state: "",
        stateId: "",
        suburbs: "",
        stateCRM: "",
        township: "",
        townshipId: "",
        street: "",
        outsideNumber: "",
        internalNumber: "",
      },
    },
  ],
};

export const dataSlice = createSlice({
  name: "beneficiaries",
  initialState,
  reducers: {
    onBeneficiaries: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { onBeneficiaries } = dataSlice.actions;

export default dataSlice.reducer;
